// extracted by mini-css-extract-plugin
module.exports = {"myToolsFooterButton":"MyToolsFooterButton_myToolsFooterButton__2AWve"};